import { TransactionWizardContext } from "../types/transactionWizardContext";
import { TransactionWizardEvent } from "../types/TransactionWizardEvent";

export const setNameAndDepotAction = (
  context: TransactionWizardContext,
  event: TransactionWizardEvent
) => {
  if (
    event.type !== "NAME_AND_DEPOT_SELECTED" &&
    event.type !== "CREATE_NEW_DEPOT"
  )
    throw new Error(`Invalid event type ${event.type}`);

  return {
    investmentValues: {
      ...context.investmentValues,
      depotId:
        event.type === "NAME_AND_DEPOT_SELECTED"
          ? event.depotId
          : context.investmentValues.depotId,
      name: event.name,
    },
    investmentNote: event.comment,
  };
};
